import { render, staticRenderFns } from "./DrawerHeader.vue?vue&type=template&id=52debef9"
import script from "./DrawerHeader.vue?vue&type=script&lang=js"
export * from "./DrawerHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports